export default {"src":"/_next/static/media/add.18c49488.svg","height":513,"width":513};